
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#8B58FB","d":"M56.43 18.33a6.02 6.02 0 018.36-2.09l1.06.65A5.98 5.98 0 0167.87 25L49.3 56.85c-2.34 4-6.64 6.45-11.28 6.41a1.3 1.3 0 01-1.18-.79 13.24 13.24 0 01.75-11.82l18.85-32.32z"}}),_c('path',{attrs:{"fill":"#B99EF4","d":"M8 39.61a6 6 0 016-6h17.06a6 6 0 015.2 9.01l-.45.76a6 6 0 01-5.19 3H14a6 6 0 01-6-6v-.77zm0 17.56a5.89 5.89 0 015.89-5.89h7.24a5.89 5.89 0 110 11.78H13.9a5.89 5.89 0 01-5.9-5.9z"}}),_c('path',{attrs:{"fill":"#8B58FB","d":"M8 21.34a5.4 5.4 0 015.4-5.4h28.02a5.4 5.4 0 110 10.8H13.4a5.4 5.4 0 01-5.4-5.4z"}})])
          )
        }
      }
    